// tslint:disable
export enum MessageContentType {
    /**
     * @description HTML
     */
    Html = 1,
    /**
     * @description Text
     */
    Text = 2,
}
(MessageContentType as any)['HTML'] = 1;
(MessageContentType as any)['TEXT'] = 2;
